<panel width="800">
	<h1>{{ 'search-ledger-posts.header' | translate }}</h1>
	<section>
		<date-input [label]="'search-ledger-posts.up-to-date' | translate" [(value)]="maxPlannedDate" [maxDate]="maxAllowedLookAhead" />
		<custom-input inputType="radio" [(value)]="brandId">
			@for (brand of brands; track brand.id) {
				<radio-button [value]="brand.id" label="{{ brand.name }}" />
			}
		</custom-input>
	</section>
	<section>
		<button confirm #searchButton (click)="searchLedgerPosts()" [label]="'search-ledger-posts.search' | translate" [ignoreValidation]="true" [active]="maxPlannedDate != undefined"></button>
	</section>
	<list-view scrollable #searchLedgersList>
		<header [sortColumn]="false"><input type="checkbox" (click)="selectAllPosts($event);" /></header>
		<header defaultSort="ascending">{{ 'general.column.company-name' | translate }}</header>
		<header>{{ 'search-ledger-posts.column.line-description' | translate }}</header>
		<header>{{ 'search-ledger-posts.column.payment-interval' | translate }}</header>
		<header>{{ 'search-ledger-posts.column.planned-date' | translate }}</header>
		<header align-right>{{ 'search-ledger-posts.column.value' | translate }}</header>
		<row *listData="let post from ledgerPosts" [disabled]="post.ledgerHeaderId" (action)="onSelectLoadBillingDetails(post)" (filteredOut)="removeSelectedPost(post);">
			<column><input type="checkbox" [attr.disabled]="post.ledgerHeaderId ? '' : null" (change)="selectPost(post);" onclick="event.stopPropagation();" [checked]="selectedLedgerPosts.indexOf(post) >= 0" /></column>
			<column [sortValue]="post.productPlan?.company.name">{{ post.productPlan?.company.name }}</column>
			<column [sortValue]="post.productPlan?.lineDescription">{{ post.lineDescription }}</column>
			<column [sortValue]="post.accountingPlan?.paymentInterval">{{ post.accountingPlan?.paymentInterval | paymentInterval}}</column>
			<column [sortValue]="post.plannedDate">{{ post.plannedDate | customDate: 'shortDate' }}</column>
			<column align-right [sortValue]="post.signedValue">{{ post.signedValue | currency }}</column>
		</row>
	</list-view>
	@if (ledgerPosts && ledgerPosts.length > 0) {
		<section>
			<button confirm #exportButton [active]="selectedLedgerPosts.length > 0" (click)="exportLedgerPosts()" [label]="'search-ledger-posts.export' | translate" [labelSaved]="'search-ledger-posts.exported-complete' | translate" [ignoreValidation]="true"></button>
		</section>
	}
</panel>

@if (highlightedLedgerPost && highlightedLedgerPost.accountingPlan) {
	<panel width="500">
		<invoice-details [accountingPlan]="highlightedLedgerPost.accountingPlan" [productPlan]="highlightedLedgerPost.productPlan" />
		@if (!loadingCustomerNo) {
			@for (setting of customerNumbers; track setting.brandId) {
				<h2>
					{{ 'invoice-details.debitor-no' | translate }} {{ setting.customerNo }} <icon small [attr.brand]="setting.brandId | brand:'shortName'" type="logo" />
				</h2>
			}
		}
		@if (loadingCompany || loadingBillingInfo) {
			<section>
				<skeletons [defaultSkeletons]="2" />
			</section>
		}
		@if (!loadingCompany && !loadingBillingInfo) {
			<company-information [company]="company" [billingInfo]="billingInfo" />
			<list-contact [company]="company" [showJustDefaultContactForBilling]="true" [enableEdit]="false" [enableDelete]="false" />
		}
	</panel>
	<panel width="600">
		<ledger-posts [productPlans]="[highlightedLedgerPost.productPlan]" [displayProductName]="false" [accountingPlan]="highlightedLedgerPost.accountingPlan" />
	</panel>
}
